import React from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {InterstateThemeProvider} from '@interstate/components/InterstateThemeProvider';
import {interstateThemeRegistry} from '@interstate/components/InterstateTheming/themes/interstateThemeRegistry';
import {AuthProvider, RequireAuth} from './context/AuthContext';
import {HealthProvider} from './context/HealthContext';
import HealthBanner from './components/HealthBanner';
import PasswordGate from './pages/PasswordGate';
import SubProcessorList from './pages/SubProcessorList';
import SubscribeForm from './pages/SubscribeForm';
import UnsubscribeForm from './pages/UnsubscribeForm';

const router = createBrowserRouter([
  {
    path: '/',
    element: <PasswordGate />
  },
  {
    path: '/login',
    element: <PasswordGate />
  },
  {
    path: '/list',
    element: 
      <RequireAuth>
        <SubProcessorList />
      </RequireAuth>
    
  },
  {
    path: '/subscribe',
    element: 
      <RequireAuth>
        <SubscribeForm />
      </RequireAuth>
    
  },
  {
    path: '/unsubscribe',
    element: 
      <RequireAuth>
        <UnsubscribeForm />
      </RequireAuth>
    
  }
]);

export default function App(): React.ReactElement {
  return (
    <InterstateThemeProvider
      themeName="Interstate"
      themeRegistries={[interstateThemeRegistry]}
      applicationName="Sub-Processor Registry"
      scopeName="subprocessor-portal"
    >
      <HealthProvider>
        <HealthBanner />
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </HealthProvider>
    </InterstateThemeProvider>
  );
}
